



interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface CheckListSection {
    heading?: string;
    para?: string;
    items: any;

}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    sideEffects: ListSection;

}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const beardlaser: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "beard-laser-hair-removal",
        "meta": {
            "title": "Beard Laser Hair Removal & Sculpting Dubai | Elite Body Home",
            "description": "Precision beard shaping and removal with advanced laser technology for a clean, polished look that lasts. Get sharp, defined beard lines without daily shaving.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/beard-laser-hair-removal/",
            "og": {
                "title": "Beard Laser Hair Removal & Sculpting Dubai | Elite Body Home",
                "description": "Get sharp, defined beard lines with our advanced laser beard sculpting treatments",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/beard-laser-treatment.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Beard Laser Hair Removal"],
        "hero": {
            "title": "Beard Laser Hair Removal & Sculpting",
            "subtitle": "Sharp, Defined Beard Lines Without Daily Shaving",
            "description": "With a hectic lifestyle, beard grooming should not become your latest worry in life. Elite Body Home offers Laser Hair Removal Beard treatments ideal for men seeking precision and efficiency. Using sophisticated and cutting-edge technology we give you striking, defined lines and a clean, polished look that lasts, freeing up extra time to focus on your goals while feeling effortlessly confident 24/7!"
        },
        "howItWorks": {
            "title": "Beard Laser Sculpting & Removal Treatment",
            "description": "Dubai's Laser beard shaping involves numerous steps, and these need to be carried out properly:"
        },
        "procedureSteps": {
            "heading": "Beard Laser Procedure Steps",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "An expert dermatologist will diagnose and analyze your skin type, hair growth pattern, and desired beard style.",
                    "icon": "fa-solid fa-comments"
                },
                {
                    "title": "Preparation",
                    "desc": "The area is dried and then, a cooling gel is applied.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Laser Procedure",
                    "desc": "It delivers pulses of controlled light at the right hair follicles with a laser device.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Customization",
                    "desc": "The laser is customized according to your hair thickness and skin color or based on the results.",
                    "icon": "fa-solid fa-sliders-h"
                },
                {
                    "title": "Procedure Completion",
                    "desc": "The process with this method is swift (20-40 minutes) and efficient.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Laser Beard Sculpting",

            "para": "Unlike any other method, beard line laser hair removal gives accurate results with no fuss or inconvenience to the patient, offering permanent reduction of unwanted hair growth.",
            "items": [
                {
                    "title": "Sharp defined beard lines",
                    "desc": "",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "No need for daily shaving",
                    "desc": "",
                    "icon": "fa-solid fa-shower"
                },
                {
                    "title": "Long-lasting results",
                    "desc": "",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Smooth, bump-free skin",
                    "desc": "",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Customized to your style",
                    "desc": "",
                    "icon": "fa-solid fa-user-tie"
                },
                {
                    "title": "Safe and non-invasive",
                    "desc": "",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Boosts confidence",
                    "desc": "",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "Gets rid of ingrown hairs",
                    "desc": "",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "eligibility": {
            "heading": "Common Areas for Laser Hair Removal",
            "subheading": "",
            "para": "Laser hair removal for men serves as a versatile solution for achieving smooth and groomed skin. It consistently eliminates hair in different parts of the body for an extended period.",
            "items": [
                {
                    "title": "Face and Neck",
                    "desc": "",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Chest and Back",
                    "desc": "",
                    "icon": "fa-solid fa-male"
                },
                {
                    "title": "Arms and Underarms",
                    "desc": "",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Legs",
                    "desc": "",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "Shoulders",
                    "desc": "",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Private Areas",
                    "desc": "",
                    "icon": "fa-solid fa-lock"
                }
            ]
        },
        "sideEffects": {
            "heading": "Side Effects of Beard Laser Hair Removal",

            "para": "Although it's generally safe, beard laser hair removal may cause minor side effects, including:",
            "items": [
                {
                    "title": "Minor redness or swelling",
                    "desc": "In the treated area",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "Skin tenderness",
                    "desc": "A few hours following the treatment",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "Pigmentation changes",
                    "desc": "Temporary skin lightening or darkening",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "Mild dryness or flakiness",
                    "desc": "Easily remedied with lotion",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "Rare risks",
                    "desc": "Burns, scarring or blistering (only if not done properly)",
                    "icon": "fa-solid fa-radiation-alt"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "",
            "para": "After a laser beard treatment, there may be some mild redness or tingling, but this typically resolves within hours. To enhance your outcome:",
            "items": [
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Wear sunscreen and avoid direct sun exposure for at least a week.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Gentle Skin Care",
                    "desc": "Use gentle cleansers and lotions; avoid irritating products.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "Cold Compresses",
                    "desc": "If necessary, cold compresses can be applied to the treated area to relieve discomfort.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Hydration",
                    "desc": "Moisten the area while it heals.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },

        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": []
        }
    },
    "ar": {
        "url": "beard-laser-hair-removal",
        "meta": {
            "title": "إزالة شعر اللحية بالليزر في دبي | ايليت بودي هوم",
            "description": "خدمات تحديد وإزالة شعر اللحية بالليزر للحصول على مظهر مثالي ونظيف يدوم طويلاً",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/ar/services/beard-laser-hair-removal",
            "og": {
                "title": "إزالة شعر اللحية بالليزر في دبي | ايليت بودي هوم",
                "description": "احصل على خطوط لحية حادة ومحددة بتقنية الليزر المتطورة",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/beard-laser-treatment-ar.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة شعر اللحية بالليزر"],
        "hero": {
            "title": "إزالة شعر اللحية بالليزر وتحديدها",
            "subtitle": "خطوط لحية حادة بدون الحاجة للحلاقة اليومية",
            "description": "في خضم نمط الحياة المزدحم، ينبغي ألا يكون الحفاظ على مظهر لحيتك مصدرًا للقلق. تُقدم ايليت بودي هوم حلاً سلسًا لإزالة شعر اللحية بالليزر، صُمم خصيصًا للرجال الذين يُقدرون الدقة والكفاءة. نساعدك في إزالة الشعر الزائد وتحقيق التحديد المطلوب و الحصول على إطلالة نظيفة وأنيقة تدوم طويلاً بفضل التكنولوجيا المتقدمة لتتمكن من التركيز على أهدافك، مع الحفاظ على ثقتك الكاملة كل يوم، وبكل سهولة."
        },
        "howItWorks": {
            "title": "إجراء تحديد اللحية بالليزر وإزالتها",
            "description": "يشمل تحديد اللحية بالليزر في دبي مجموعة من المراحل التي يجب تنفيذها بدقة لضمان أفضل النتائج، إليك المراحل بالتفصيل:"
        },
        "procedureSteps": {
            "heading": "خطوات إجراء تحديد اللحية بالليزر",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يُجري طبيب الجلدية المختص تقييماً لنوع بشرتك، ونمط نمو الشعر، وشكل اللحية المطلوب.",
                    "icon": "fa-solid fa-comments"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف المنطقة جيدًا، ثم يوضَع جل مُهدئ لتهيئة البشرة قبل الجلسة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "إجراء الليزر",
                    "desc": "يُستخدم جهاز ليزر متطور لإصدار نبضات ضوئية دقيقة تستهدف بصيلات الشعر بشكل فعال.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "التخصيص",
                    "desc": "يتم ضبط إعدادات الليزر بناءً على كثافة الشعر، ولون البشرة، والنتائج المطلوبة لضمان دقة وأمان العلاج.",
                    "icon": "fa-solid fa-sliders-h"
                },
                {
                    "title": "تنفيذ الإجراء",
                    "desc": "العملية سريعة وفعالة وتستغرق حوالي 20 إلى 40 دقيقة فقط، مما يمنحك إطلالة مثالية بكل راحة.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد الاستثنائية لعلاج اللحية بالليزر",
            "para": "يوفر إزالة شعر اللحية بالليزر حلاً دقيقًا وسهلًا للحصول على خطوط لحية حادة ومحددة بدقة مع تقليل نمو الشعر غير المرغوب فيه بشكل دائم.",
            "items": [
                {
                    "title": "خطوط لحية مثالية ومحددة بدقة",
                    "desc": "",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "التخلص من الحاجة للحلاقة اليومية",
                    "desc": "",
                    "icon": "fa-solid fa-shower"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "بشرة ناعمة خالية من العيوب",
                    "desc": "",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "إجراء مخصص ليناسب أسلوبك الخاص",
                    "desc": "",
                    "icon": "fa-solid fa-user-tie"
                },
                {
                    "title": "إجراء آمن وغير جراحي",
                    "desc": "",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "يعزز الثقة بالنفس",
                    "desc": "",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "يمنع نمو الشعر تحت الجلد",
                    "desc": "",
                    "icon": "fa-solid fa-ban"
                }
            ]
        },
        "eligibility": {
            "heading": "المناطق الشائعة لإزالة الشعر بالليزر للرجال",
            "subheading": "",
            "para": "يعد إزالة الشعر بالليزر حل مثالي للرجال الذين يسعون للحصول على مظهر ناعم وأنيق، حيث يُستهدف الشعر غير المرغوب فيه بفعالية، مما يمنحك نتائج طويلة الأمد.",
            "items": [
                {
                    "title": "الوجه والرقبة",
                    "desc": "",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "الصدر والظهر",
                    "desc": "",
                    "icon": "fa-solid fa-male"
                },
                {
                    "title": "الذراعين وتحت الإبطين",
                    "desc": "",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "الساقين",
                    "desc": "",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "الكتفين",
                    "desc": "",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "المناطق الخاصة",
                    "desc": "",
                    "icon": "fa-solid fa-lock"
                }
            ]
        },
        "sideEffects": {
            "heading": "الآثار الجانبية لإزالة شعر اللحية بالليزر",

            "para": "على الرغم من أن إجراء إزالة شعر اللحية بالليزر يعتبر آمن وفعال، قد يعاني بعض الأشخاص من آثار جانبية طفيفة، تشمل:",
            "items": [
                {
                    "title": "احمرار مؤقت أو تورم خفيف",
                    "desc": "في المنطقة المعالجة",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "حساسية في البشرة",
                    "desc": "لبضع ساعات بعد الجلسة",
                    "icon": "fa-solid fa-hand-holding-heart"
                },
                {
                    "title": "تغيرات في تصبغ الجلد",
                    "desc": "تفتح أو اسمرار مؤقت في البشرة",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "جفاف بسيط أو تقشر خفيف",
                    "desc": "يمكن التحكم فيه باستخدام المرطبات",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "مخاطر نادرة",
                    "desc": "حروق، أو ندوب، أو بثور (في حال عدم تنفيذ الإجراء بشكل صحيح)",
                    "icon": "fa-solid fa-radiation-alt"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح للعناية بعد إزالة الشعر بالليزر",
            "subheading": "",
            "para": "يمكن ملاحظة احمرارًا خفيفًا أو شعورًا بوخز بسيط بعد جلسة إزالة شعر اللحية بالليزر لكنه عادةً ما يزول خلال بضع ساعات. لتعزيز النتائج وسرعة التعافي يُنصح بـ:",
            "items": [
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "استخدم واقي الشمس، وتجنب التعرض المباشر لأشعة الشمس لمدة أسبوع على الأقل.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "العناية اللطيفة بالبشرة",
                    "desc": "استخدم منظفات ومرطبات لطيفة، وتجنب المنتجات القاسية على البشرة.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "استخدام الكمادات الباردة",
                    "desc": "يمكن استخدام الكمادات الباردة لتهدئة البشرة إذا لزم الأمر.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "الترطيب المستمر",
                    "desc": "حافظ على ترطيب البشرة لتسريع عملية الشفاء.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },

        "faqData": {
            "heading": "الأسئلة المتكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم عدد الجلسات المطلوبة؟",
                    "answer": "يتطلب من 4 إلى 6 جلسات في أغلب الأحيان، وذلك حسب نوع الشعر، ولون البشرة، والدورة الطبيعية للجسم. تكمن فكرة العلاج في استهداف البصيلات النشطة، لذلك سيتم استهدافها بشكل كامل بعد عدة جلسات."
                },
                {
                    "question": "هل علاج اللحية بالليزر مؤلم؟",
                    "answer": "لا، هو شبه خالٍ من الألم، يشعر معظم العملاء بوخز خفيف جدًا، كما يضمن جل التبريد لدينا أقصى درجات الراحة."
                },
                {
                    "question": "هل إزالة الشعر بالليزر آمنة للرجال؟",
                    "answer": "نعم، يعد إجراء آمن وفعال في حال إجرائه بواسطة مُختصين مُدربين وباستخدام تقنية متقدمة."
                },
                {
                    "question": "هل يمكنني الحلاقة بين الجلسات؟",
                    "answer": "نعم، يُسمح بالحلاقة بين الجلسات، لكن يجب تجنب إزالة الشعر بالشمع أو النتف، لأنها تؤثر على بصيلات الشعر وتعيق فعالية العلاج."
                },
                {
                    "question": "هل تحديد اللحية بالليزر دائم؟",
                    "answer": "تدوم النتائج طويلًا، لكن قد تكون هناك حاجة إلى جلسات متابعة للحفاظ على الشكل المثالي."
                },
                {
                    "question": "ما هي تكلفة إزالة شعر اللحية بالليزر في دبي؟",
                    "answer": "تختلف تكلفة إزالة شعر اللحية بالليزر في دبي حسب منطقة العلاج، وعدد الجلسات المطلوبة، ونوع الشعر الخاص بك. نقدم باقات مخصصة تناسب احتياجاتك، مما يضمن لك أسعارًا مناسبة دون التضحية بالجودة. للحصول على عرض سعر دقيق، نوصي بحجز استشارة مع خبرائنا. تواصل معنا اليوم لمعرفة التفاصيل والعروض الخاصة!"
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/header.jpg",
            "beforeAfter": [
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/1-3.jpg",
                    "alt": "beard treatment"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/5-1.jpg",
                    "alt": "beard treatment"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/3-1.jpg",
                    "alt": "beard treatment"
                },
                {
                    "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/2-2.jpg",
                    "alt": "beard treatment"
                }
            ]
        },
        "product": {
            "id": 48,
            "title": "Beard Laser Hair Removal & Sculpting",
            "description": "Get sharp, defined beard lines with our advanced laser beard sculpting treatments",
            "price": 700
        }
    }
}